import {
  ArrowsUpDownIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/16/solid";

const icons = {
  asc: <ChevronUpIcon />,
  desc: <ChevronDownIcon />,
};

export default function SortIcon({ header }) {
  const sortIcon = icons[header.column.getIsSorted()];
  if (sortIcon) return sortIcon;
  if (header.column.getCanSort()) {
    return <ArrowsUpDownIcon className="fill-cp-grey-500" />;
  }
  return <></>;
}
